module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "alert-messages"
    }
  }, _vm._l((_vm.alerts), function(alert, index) {
    return _c('div', {
      key: index,
      staticClass: "col-12",
      attrs: {
        "id": alert
      }
    }, [(alert.boardCreationMode) ? _c('b-alert', {
      attrs: {
        "show": true,
        "dismissible": "",
        "fade": "",
        "variant": "info"
      },
      on: {
        "dismissed": function($event) {
          return _vm.cancelBoardCreation(index)
        }
      }
    }, [_vm._v("\n      Mot à faire deviner : "), _c('u', [_vm._v(_vm._s(_vm.currentBoardWords[0]))]), _vm._v(" \n      ~~ "), _c('b-link', {
      staticClass: "alert-link",
      on: {
        "click": function($event) {
          return _vm.saveBoard(index)
        }
      }
    }, [_vm._v("Enregistrer le plateau")]), _vm._v(" ~~\n    ")], 1) : _c('b-alert', {
      attrs: {
        "show": alert.dismissCountDown,
        "dismissible": "",
        "fade": "",
        "variant": alert.variant
      },
      on: {
        "dismissed": function($event) {
          return _vm.removeCurrentAlert(index)
        },
        "dismiss-count-down": function($event) {
          return _vm.countDownChanged()
        }
      }
    }, [_vm._v("\n      " + _vm._s(alert.msg) + "\n    ")])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5176ea40","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alerts.vue
// module id = Wddc
// module chunks = 1